import * as yup from 'yup';
import { emailSchema, requiredErrorMessage, textSchema } from '@common/schema';

export const resetPasswordSchema = yup.object().shape({
  email: emailSchema.required(requiredErrorMessage),
  captcha_answer: textSchema
    .required(requiredErrorMessage)
    .max(5, 'The answer must be at most 5 characters'),
});
